import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { Toaster } from "@/components/ui/sonner.tsx"
import { router } from "./routes"
import { ThemeProvider } from "@mui/material/styles"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { Provider } from "react-redux"
import { RouterProvider } from "react-router-dom"
import theme from "@/theme"
import store from "./redux/store"
import { CssBaseline } from "@mui/material"
import "@mantine/core/styles.css"
import { MantineProvider } from "@mantine/core"
import ErrorBoundary from "./ErrorBoundary"

const queryClient = new QueryClient()

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <>
      <Toaster position="top-right" richColors closeButton theme="light" />
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} position="bottom" />
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Provider store={store}>
            <MantineProvider>
              <ErrorBoundary>
                <RouterProvider router={router} />
              </ErrorBoundary>
            </MantineProvider>
          </Provider>
        </ThemeProvider>
      </QueryClientProvider>
    </>
  </StrictMode>
)
